import React from 'react';
import { Empty, type EmptyProps } from 'antd';
import classNames from 'classnames';

import s from './styles.module.scss';

interface IBaseEmptyProps extends EmptyProps {
  className?: string;
  description?: React.ReactNode;
}

const BaseEmpty: React.FC<IBaseEmptyProps> = ({
  className,
  description = 'No data.',
  ...props
}) => {
  return (
    <Empty
      className={classNames(s['empty-state'], className)}
      description={description}
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      {...props}
    />
  );
};
export default BaseEmpty;
